module.exports = __webpack_public_path__ + "static/media/carrozzeria_ognibene.37b43f96.jpeg";